import React from "react";

/*
 * Self-contained inline SVG icon set — no external icon library.
 * Usage: <Icon name="leaf" />
 */
const paths = {
  leaf: (
    <path d="M4 20c0-9 6-15 16-16-1 10-7 16-16 16Zm0 0c2-4 5-7 9-9" />
  ),
  hands: (
    <>
      <path d="M7 12V6a2 2 0 1 1 4 0v5" />
      <path d="M11 11V4a2 2 0 1 1 4 0v7" />
      <path d="M15 11V6a2 2 0 1 1 4 0v8c0 4-3 7-7 7h-1c-3.5 0-5.5-1.5-7-4l-2-4c-.6-1.2.5-2.6 1.8-2.2l2.2.9" />
    </>
  ),
  gift: (
    <>
      <rect x="4" y="9" width="16" height="11" rx="1.5" />
      <path d="M4 13h16" />
      <path d="M12 9v11" />
      <path d="M12 9C9 9 8 7.5 8 6a2 2 0 1 1 4 0Z" />
      <path d="M12 9c3 0 4-1.5 4-3a2 2 0 1 0-4 0Z" />
    </>
  ),
  recycle: (
    <path d="M7 19H4.8a2 2 0 0 1-1.7-3l3-5.2M11 5.5 13 2l3.3 3.5M18 12l2.2 3.8a2 2 0 0 1-1.7 3H15M9 19h6M9.5 8.5 12 13l-2.3 4M14.5 8.5 17 13" />
  ),
  people: (
    <>
      <circle cx="9" cy="8" r="3" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M3.5 20c.6-3.4 2.9-5.5 5.5-5.5s4.9 2.1 5.5 5.5" />
      <path d="M15.5 15c2 0 4 1.7 4.5 5" />
    </>
  ),
  growth: (
    <path d="M4 19h16M6 19V11l4-3 4 3v8M14 19v-4l4-2v6" />
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c2.5 2.6 3.8 5.7 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.7-3.8-9S9.5 5.6 12 3Z" />
    </>
  ),
  farmer: (
    <>
      <circle cx="12" cy="6" r="2.5" />
      <path d="M6 20c.7-4.2 3-6.5 6-6.5s5.3 2.3 6 6.5" />
      <path d="M4 20h16" />
    </>
  ),
  heart: (
    <path d="M12 20s-7-4.3-9.5-8.7C.7 8 2 4.5 5.4 4c2-.3 3.7.7 4.6 2.2C10.9 4.7 12.6 3.7 14.6 4c3.4.5 4.7 4 3 7.3C15 15.7 12 20 12 20Z" />
  ),
  arrow: <path d="M5 12h14M13 6l6 6-6 6" />,
  chevronLeft: <path d="M15 6l-6 6 6 6" />,
  chevronRight: <path d="M9 6l6 6-6 6" />,
  quote: (
    <path d="M9 7C6 8 4.5 10 4.5 13c0 2 1.3 3.5 3 3.5S10 15 10 13.3c0-1.4-.9-2.5-2.2-2.7C8.2 9 9.4 8 11 7.2L9 7Zm9 0c-3 1-4.5 3-4.5 6 0 2 1.3 3.5 3 3.5S19 15 19 13.3c0-1.4-.9-2.5-2.2-2.7C17.2 9 18.4 8 20 7.2L18 7Z" />
  ),
  mail: (
    <>
      <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
      <path d="M4.5 6.5 12 12.5l7.5-6" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s7-6.4 7-11.5a7 7 0 1 0-14 0C5 14.6 12 21 12 21Z" />
      <circle cx="12" cy="9.5" r="2.5" />
    </>
  ),
  phone: (
    <path d="M6 3h3l1.5 4.5-2 1.5a12 12 0 0 0 6.5 6.5l1.5-2L21 15v3a2 2 0 0 1-2 2c-8.3 0-15-6.7-15-15a2 2 0 0 1 2-2Z" />
  ),
  facebook: <path d="M14 9h3V6h-3c-2 0-3.5 1.5-3.5 3.5V11H8v3h2.5v7h3v-7H16l.5-3h-3V9.8c0-.5.2-.8.7-.8Z" />,
  instagram: (
    <>
      <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17" cy="7" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  youtube: (
    <>
      <rect x="2.5" y="6" width="19" height="12" rx="3" />
      <path d="M10.5 9.5v5l4.5-2.5-4.5-2.5Z" fill="currentColor" stroke="none" />
    </>
  ),
  pinterest: (
    <path d="M8 20c.3-1.3.7-3.2 1-4.5M12 4a7 7 0 0 0-2.5 13.5c0-.9 0-1.9.3-2.9L11 9.5s-.3-.7-.3-1.7c0-1.6 1-2.8 2.2-2.8 1 0 1.5.8 1.5 1.7 0 1-.7 2.5-1 3.9-.3 1.1.6 2 1.7 2 2 0 3.4-2.5 3.4-5.5C18.5 5 16.1 4 13.9 4H12Z" />
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.3-4.3" />
    </>
  ),
  linkedin: (
    <>
      <rect x="3.5" y="3.5" width="17" height="17" rx="3" />
      <circle cx="8" cy="8.5" r="1.2" fill="currentColor" stroke="none" />
      <path d="M8 11v6M12 17v-3.5c0-1.4 1-2.5 2.3-2.5S16.5 12.1 16.5 13.5V17" />
    </>
  ),
  checkCircle: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="m8.5 12.5 2.3 2.3L16 9.5" />
    </>
  ),
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  close: <path d="M6 6l12 12M18 6 6 18" />,
  star: (
    <path d="M12 3.5l2.5 5.3 5.7.8-4.2 4.1 1 5.8L12 16.6l-5 2.9 1-5.8-4.2-4.1 5.7-.8L12 3.5Z" />
  ),
};

export default function Icon({ name, size = 22, strokeWidth = 1.7, className = "" }) {
  const content = paths[name];
  if (!content) return null;
  return (
    <svg
      className={`tp-icon ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {content}
    </svg>
  );
}
